// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/policy/v1/policy_steps_approval.proto" (package "c1.api.policy.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { SkippedAction } from "./shared_policy_outcomes";
import { RestartAction } from "./shared_policy_outcomes";
import { ReassignedAction } from "./shared_policy_outcomes";
/**
 * @generated from protobuf message c1.api.policy.v1.Approval
 */
export interface Approval {
    /**
     * Configuration to allow reassignment by reviewers during this step.
     *
     * @generated from protobuf field: bool allow_reassignment = 1
     */
    allowReassignment: boolean;
    /**
     * Configuration to require a reason when reassigning this step.
     *
     * @generated from protobuf field: bool require_reassignment_reason = 2
     */
    requireReassignmentReason: boolean;
    /**
     * A field indicating whether this step is assigned.
     *
     * @generated from protobuf field: bool assigned = 3
     */
    assigned: boolean;
    /**
     * Configuration to require a reason when approving this step.
     *
     * @generated from protobuf field: bool require_approval_reason = 4
     */
    requireApprovalReason: boolean;
    /**
     * Configuration to require a reason when denying this step.
     *
     * @generated from protobuf field: bool require_denial_reason = 5
     */
    requireDenialReason: boolean;
    /**
     * The ID of a step-up authentication provider that will be required for approvals on this step.
     * If set, approvers must complete the step-up authentication flow before they can approve.
     *
     * @generated from protobuf field: string requires_step_up_provider_id = 6
     */
    requiresStepUpProviderId: string;
    /**
     * List of users for whom this step can be reassigned.
     *
     * @generated from protobuf field: repeated string allowed_reassignees = 7
     */
    allowedReassignees: string[];
    /**
     * @generated from protobuf oneof: typ
     */
    typ: {
        oneofKind: "users";
        /**
         * Part of the typ oneOf, indicating that the specific users will be reviewing this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.UserApproval users = 100
         */
        users: UserApproval;
    } | {
        oneofKind: "manager";
        /**
         * Part of the typ oneOf, indicating that the target's manager will be reviewing this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.ManagerApproval manager = 101
         */
        manager: ManagerApproval;
    } | {
        oneofKind: "appOwners";
        /**
         * Part of the typ oneOf, indicating that app owners will be approving this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.AppOwnerApproval app_owners = 102
         */
        appOwners: AppOwnerApproval;
    } | {
        oneofKind: "group";
        /**
         * Part of the typ oneOf, indicating that a specified group will be reviewing this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.AppGroupApproval group = 103
         */
        group: AppGroupApproval;
    } | {
        oneofKind: "self";
        /**
         * Part of the typ oneOf, indicating that the target must themselves review this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.SelfApproval self = 104
         */
        self: SelfApproval;
    } | {
        oneofKind: "entitlementOwners";
        /**
         * Part of the typ oneOf, indicating that entitlements owners will be reviewing this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.EntitlementOwnerApproval entitlement_owners = 105
         */
        entitlementOwners: EntitlementOwnerApproval;
    } | {
        oneofKind: "expression";
        /**
         * Part of the typ oneOf, indicating that the relevant users will be calculated from an dynamic expression.
         *
         * @generated from protobuf field: c1.api.policy.v1.ExpressionApproval expression = 106
         */
        expression: ExpressionApproval;
    } | {
        oneofKind: "webhook";
        /**
         * Part of the type oneOf, indicating which webhook is run when this step is processed.
         *
         * @generated from protobuf field: c1.api.policy.v1.WebhookApproval webhook = 107
         */
        webhook: WebhookApproval;
    } | {
        oneofKind: "resourceOwners";
        /**
         * Part of the typ oneOf, indicating that resources owners will be reviewing this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.ResourceOwnerApproval resource_owners = 108
         */
        resourceOwners: ResourceOwnerApproval;
    } | {
        oneofKind: "agent";
        /**
         * Part of the typ oneOf, indicating that an agent will be reviewing this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.AgentApproval agent = 109
         */
        agent: AgentApproval;
    } | {
        oneofKind: undefined;
    };
    /**
     * Whether escalation is enabled for this step.
     *
     * @generated from protobuf field: bool escalation_enabled = 8
     */
    escalationEnabled: boolean;
    /**
     * The escalation configuration for this step.
     *
     * @generated from protobuf field: c1.api.policy.v1.Escalation escalation = 9
     */
    escalation?: Escalation;
    /**
     * Whether ticket delegation is allowed for this step.
     *
     * @generated from protobuf field: bool allow_delegation = 10
     */
    allowDelegation: boolean;
}
/**
 * The approval instance object describes the way a policy step should be approved as well as its outcomes and state.
 *
 * @generated from protobuf message c1.api.policy.v1.ApprovalInstance
 */
export interface ApprovalInstance {
    /**
     * A reference to the approval object, indicating who should be approving this step.
     *
     * @generated from protobuf field: c1.api.policy.v1.Approval approval = 1
     */
    approval?: Approval;
    /**
     * The state of the approval instance
     *
     * @generated from protobuf field: c1.api.policy.v1.ApprovalInstanceState state = 2
     */
    state: ApprovalInstanceState;
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "approved";
        /**
         * Part of the outcome oneOf, A record of an approval action taken on this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.ApprovedAction approved = 101
         */
        approved: ApprovedAction;
    } | {
        oneofKind: "denied";
        /**
         * Part of the outcome oneOf, A record of a denied action taken on this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.DeniedAction denied = 102
         */
        denied: DeniedAction;
    } | {
        oneofKind: "reassigned";
        /**
         * Part of the outcome oneOf, A record of a reassigned action taken on this step.
         *
         * @generated from protobuf field: c1.api.policy.v1.ReassignedAction reassigned = 103
         */
        reassigned: ReassignedAction;
    } | {
        oneofKind: "restarted";
        /**
         * Part of the outcome oneOf, A record of the task restarting, setting pending action outcomes to restart.
         *
         * @generated from protobuf field: c1.api.policy.v1.RestartAction restarted = 104
         */
        restarted: RestartAction;
    } | {
        oneofKind: "reassignedByError";
        /**
         * Part of the outcome oneOf, A record of the system reassigning this step because it encountered an error.
         *
         * @generated from protobuf field: c1.api.policy.v1.ReassignedByErrorAction reassigned_by_error = 105
         */
        reassignedByError: ReassignedByErrorAction;
    } | {
        oneofKind: "skipped";
        /**
         * Part of the outcome oneOf, A record of the step being skipped.
         *
         * @generated from protobuf field: c1.api.policy.v1.SkippedAction skipped = 106
         */
        skipped: SkippedAction;
    } | {
        oneofKind: undefined;
    };
    /**
     * The escalation instance for this step.
     *
     * @generated from protobuf field: c1.api.policy.v1.EscalationInstance escalation_instance = 3
     */
    escalationInstance?: EscalationInstance;
    /**
     * The timestamp when this approval instance was assigned to the current approver(s).
     *
     * @generated from protobuf field: google.protobuf.Timestamp assigned_at = 4
     */
    assignedAt?: Timestamp;
}
/**
 * The approved action indicates that the approvalinstance had an outcome of approved.
 *
 * @generated from protobuf message c1.api.policy.v1.ApprovedAction
 */
export interface ApprovedAction {
    /**
     * The UserID that approved this step.
     *
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * The entitlements that were approved. This will only ever be a list of one entitlement.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.AppEntitlementReference entitlements = 2
     */
    entitlements: AppEntitlementReference[];
    /**
     * The datetime, in RFC3339 format, of when the step was approved.
     *
     * @generated from protobuf field: google.protobuf.Timestamp approved_at = 3
     */
    approvedAt?: Timestamp;
    /**
     * The ID of the step-up transaction that was used for this approval, if step-up was required.
     *
     * @generated from protobuf field: string step_up_transaction_id = 4
     */
    stepUpTransactionId: string;
}
/**
 * This object references an app entitlement's ID and AppID.
 *
 * @generated from protobuf message c1.api.policy.v1.AppEntitlementReference
 */
export interface AppEntitlementReference {
    /**
     * The ID of the App this entitlement belongs to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the Entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
}
/**
 * The denied action indicates that the c1.api.policy.v1.ApprovalInstance had an outcome of denied.
 *
 * @generated from protobuf message c1.api.policy.v1.DeniedAction
 */
export interface DeniedAction {
    /**
     * The UserID that denied this step.
     *
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * The datetime, in RFC3339 format, of when the step (and task) was denied.
     *
     * @generated from protobuf field: google.protobuf.Timestamp denied_at = 2
     */
    deniedAt?: Timestamp;
}
/**
 * The user approval object describes the approval configuration of a policy step that needs to be approved by a specific list of users.
 *
 * @generated from protobuf message c1.api.policy.v1.UserApproval
 */
export interface UserApproval {
    /**
     * Array of users configured for approval.
     *
     * @generated from protobuf field: repeated string user_ids = 1
     */
    userIds: string[];
    /**
     * Configuration to allow self approval of if the user is specified and also the target of the ticket.
     *
     * @generated from protobuf field: bool allow_self_approval = 2
     */
    allowSelfApproval: boolean;
    /**
     * Configuration to require distinct approvers across approval steps of a rule.
     *
     * @generated from protobuf field: bool require_distinct_approvers = 3
     */
    requireDistinctApprovers: boolean;
}
/**
 * The agent to assign the task to.
 *
 * @generated from protobuf message c1.api.policy.v1.AgentApproval
 */
export interface AgentApproval {
    /**
     * The agent user ID to assign the task to.
     *
     * @generated from protobuf field: string agent_user_id = 1
     */
    agentUserId: string;
    /**
     * Instructions for the agent.
     *
     * @generated from protobuf field: string instructions = 2
     */
    instructions: string;
    /**
     * The allow list of policy IDs to re-route the task to.
     *
     * @generated from protobuf field: repeated string policy_ids = 3
     */
    policyIds: string[];
    /**
     * The mode of the agent, full control, change policy only, or comment only.
     *
     * @generated from protobuf field: c1.api.policy.v1.ApprovalAgentMode agent_mode = 4
     */
    agentMode: ApprovalAgentMode;
    /**
     * The action to take if the agent fails to approve, deny, or reassign the task.
     *
     * @generated from protobuf field: c1.api.policy.v1.ApprovalAgentFailureAction agent_failure_action = 5
     */
    agentFailureAction: ApprovalAgentFailureAction;
    /**
     * The users to reassign the task to if the agent failure action is reassign to users.
     *
     * @generated from protobuf field: repeated string reassign_to_user_ids = 6
     */
    reassignToUserIds: string[];
}
/**
 * The manager approval object provides configuration options for approval when the target of the approval is the manager of the user in the task.
 *
 * @generated from protobuf message c1.api.policy.v1.ManagerApproval
 */
export interface ManagerApproval {
    /**
     * Configuration to specific which users to fallback to if fallback is enabled and no manager is found.
     *
     * @generated from protobuf field: repeated string fallback_user_ids = 1
     */
    fallbackUserIds: string[];
    /**
     * Configuration to allow a fallback if no manager is found.
     *
     * @generated from protobuf field: bool fallback = 2
     */
    fallback: boolean;
    /**
     * Configuration to allow self approval if the target user is their own manager. This may occur if a service account has an identity user and manager specified as the same person.
     *
     * @generated from protobuf field: bool allow_self_approval = 3
     */
    allowSelfApproval: boolean;
    /**
     * The array of users determined to be the manager during processing time.
     *
     * @generated from protobuf field: repeated string assigned_user_ids = 4
     */
    assignedUserIds: string[];
    /**
     * Configuration to require distinct approvers across approval steps of a rule.
     *
     * @generated from protobuf field: bool require_distinct_approvers = 5
     */
    requireDistinctApprovers: boolean;
    /**
     * Configuration to specify which groups to fallback to if fallback is enabled and no manager is found.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 6
     */
    fallbackGroupIds: AppEntitlementReference[];
    /**
     * Configuration to enable fallback for group fallback.
     *
     * @generated from protobuf field: bool is_group_fallback_enabled = 7
     */
    isGroupFallbackEnabled: boolean;
}
/**
 * App owner approval provides the configuration for an approval step when the app owner is the target.
 *
 * @generated from protobuf message c1.api.policy.v1.AppOwnerApproval
 */
export interface AppOwnerApproval {
    /**
     * Configuration that allows a user to self approve if they are an app owner during this approval step.
     *
     * @generated from protobuf field: bool allow_self_approval = 1
     */
    allowSelfApproval: boolean;
    /**
     * Configuration to require distinct approvers across approval steps of a rule.
     *
     * @generated from protobuf field: bool require_distinct_approvers = 2
     */
    requireDistinctApprovers: boolean;
}
/**
 * The entitlement owner approval allows configuration of the approval step when the target approvers are the entitlement owners.
 *
 * @generated from protobuf message c1.api.policy.v1.EntitlementOwnerApproval
 */
export interface EntitlementOwnerApproval {
    /**
     * Configuration to allow self approval if the target user is an entitlement owner during this step.
     *
     * @generated from protobuf field: bool allow_self_approval = 1
     */
    allowSelfApproval: boolean;
    /**
     * Configuration to specific which users to fallback to if fallback is enabled and the entitlement owner cannot be identified.
     *
     * @generated from protobuf field: repeated string fallback_user_ids = 2
     */
    fallbackUserIds: string[];
    /**
     * Configuration to allow a fallback if the entitlement owner cannot be identified.
     *
     * @generated from protobuf field: bool fallback = 3
     */
    fallback: boolean;
    /**
     * Configuration to require distinct approvers across approval steps of a rule.
     *
     * @generated from protobuf field: bool require_distinct_approvers = 4
     */
    requireDistinctApprovers: boolean;
    /**
     * Configuration to specify which groups to fallback to if fallback is enabled and the entitlement owner cannot be identified.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 5
     */
    fallbackGroupIds: AppEntitlementReference[];
    /**
     * Configuration to enable fallback for group fallback.
     *
     * @generated from protobuf field: bool is_group_fallback_enabled = 6
     */
    isGroupFallbackEnabled: boolean;
}
/**
 * The resource owner approval allows configuration of the approval step when the target approvers are the resource owners.
 *
 * @generated from protobuf message c1.api.policy.v1.ResourceOwnerApproval
 */
export interface ResourceOwnerApproval {
    /**
     * Configuration to allow self approval if the target user is an resource owner during this step.
     *
     * @generated from protobuf field: bool allow_self_approval = 1
     */
    allowSelfApproval: boolean;
    /**
     * Configuration to specific which users to fallback to if fallback is enabled and the resource owner cannot be identified.
     *
     * @generated from protobuf field: repeated string fallback_user_ids = 2
     */
    fallbackUserIds: string[];
    /**
     * Configuration to allow a fallback if the resource owner cannot be identified.
     *
     * @generated from protobuf field: bool fallback = 3
     */
    fallback: boolean;
    /**
     * Configuration to require distinct approvers across approval steps of a rule.
     *
     * @generated from protobuf field: bool require_distinct_approvers = 4
     */
    requireDistinctApprovers: boolean;
    /**
     * Configuration to specify which groups to fallback to if fallback is enabled and the resource owner cannot be identified.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 5
     */
    fallbackGroupIds: AppEntitlementReference[];
    /**
     * Configuration to enable fallback for group fallback.
     *
     * @generated from protobuf field: bool is_group_fallback_enabled = 6
     */
    isGroupFallbackEnabled: boolean;
}
/**
 * The self approval object describes the configuration of a policy step that needs to be approved by the target of the request.
 *
 * @generated from protobuf message c1.api.policy.v1.SelfApproval
 */
export interface SelfApproval {
    /**
     * Configuration to specific which users to fallback to if fallback is enabled and the identity user of the target app user cannot be determined.
     *
     * @generated from protobuf field: repeated string fallback_user_ids = 1
     */
    fallbackUserIds: string[];
    /**
     * Configuration to allow a fallback if the identity user of the target app user cannot be determined.
     *
     * @generated from protobuf field: bool fallback = 2
     */
    fallback: boolean;
    /**
     * The array of users determined to be themselves during approval. This should only ever be one person, but is saved because it may change if the owner of an app user changes while the ticket is open.
     *
     * @generated from protobuf field: repeated string assigned_user_ids = 3
     */
    assignedUserIds: string[];
    /**
     * Configuration to specify which groups to fallback to if fallback is enabled and the identity user of the target app user cannot be determined.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 4
     */
    fallbackGroupIds: AppEntitlementReference[];
    /**
     * Configuration to enable fallback for group fallback.
     *
     * @generated from protobuf field: bool is_group_fallback_enabled = 5
     */
    isGroupFallbackEnabled: boolean;
}
/**
 * The AppGroupApproval object provides the configuration for setting a group as the approvers of an approval policy step.
 *
 * @generated from protobuf message c1.api.policy.v1.AppGroupApproval
 */
export interface AppGroupApproval {
    /**
     * The ID of the app that contains the group specified for approval.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the group specified for approval.
     *
     * @generated from protobuf field: string app_group_id = 2
     */
    appGroupId: string;
    /**
     * Configuration to allow self approval if the target user is a member of the group during this step.
     *
     * @generated from protobuf field: bool allow_self_approval = 3
     */
    allowSelfApproval: boolean;
    /**
     * Configuration to specific which users to fallback to if fallback is enabled and the group is empty.
     *
     * @generated from protobuf field: repeated string fallback_user_ids = 4
     */
    fallbackUserIds: string[];
    /**
     * Configuration to allow a fallback if the group is empty.
     *
     * @generated from protobuf field: bool fallback = 5
     */
    fallback: boolean;
    /**
     * Configuration to specify which groups to fallback to if fallback is enabled and the group is empty.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 6
     */
    fallbackGroupIds: AppEntitlementReference[];
    /**
     * Configuration to enable fallback for group fallback.
     *
     * @generated from protobuf field: bool is_group_fallback_enabled = 7
     */
    isGroupFallbackEnabled: boolean;
    /**
     * Configuration to require distinct approvers across approval steps of a rule.
     *
     * @generated from protobuf field: bool require_distinct_approvers = 8
     */
    requireDistinctApprovers: boolean;
}
/**
 * @generated from protobuf message c1.api.policy.v1.ExpressionApproval
 */
export interface ExpressionApproval {
    /**
     * Array of dynamic expressions to determine the approvers.  The first expression to return a non-empty list of users will be used.
     *
     * @generated from protobuf field: repeated string expressions = 1
     */
    expressions: string[];
    /**
     * Configuration to allow self approval of if the user is specified and also the target of the ticket.
     *
     * @generated from protobuf field: bool allow_self_approval = 2
     */
    allowSelfApproval: boolean;
    /**
     * Configuration to allow a fallback if the expression does not return a valid list of users.
     *
     * @generated from protobuf field: bool fallback = 3
     */
    fallback: boolean;
    /**
     * Configuration to specific which users to fallback to if and the expression does not return a valid list of users.
     *
     * @generated from protobuf field: repeated string fallback_user_ids = 4
     */
    fallbackUserIds: string[];
    /**
     * @generated from protobuf field: repeated string assigned_user_ids = 5
     */
    assignedUserIds: string[];
    /**
     * Configuration to require distinct approvers across approval steps of a rule.
     *
     * @generated from protobuf field: bool require_distinct_approvers = 6
     */
    requireDistinctApprovers: boolean;
    /**
     * Configuration to specify which groups to fallback to if fallback is enabled and the expression does not return a valid list of users.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 7
     */
    fallbackGroupIds: AppEntitlementReference[];
    /**
     * Configuration to enable fallback for group fallback.
     *
     * @generated from protobuf field: bool is_group_fallback_enabled = 8
     */
    isGroupFallbackEnabled: boolean;
}
/**
 * @generated from protobuf message c1.api.policy.v1.WebhookApproval
 */
export interface WebhookApproval {
    /**
     * The ID of the webhook to call for approval.
     *
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
}
/**
 * The ReassignedByErrorAction object describes the outcome of a policy step that has been reassigned because it had an error provisioning.
 *
 * @generated from protobuf message c1.api.policy.v1.ReassignedByErrorAction
 */
export interface ReassignedByErrorAction {
    /**
     * Additional information about the error, like http status codes or error messages from SDKs.
     *
     * @generated from protobuf field: string error_code = 1
     */
    errorCode: string;
    /**
     * The description of the error with more details on why this was reassigned.
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * The UserID of the user who reassigned this due to an error. This will exclusively be the System's UserID.
     *
     * @generated from protobuf field: string error_user_id = 3
     */
    errorUserId: string;
    /**
     * The ID of the policy step that was created by this reassignment.
     *
     * @generated from protobuf field: string new_policy_step_id = 4
     */
    newPolicyStepId: string;
    /**
     * The datetime, in RFC3339 format, of when the step errored.
     *
     * @generated from protobuf field: google.protobuf.Timestamp errored_at = 5
     */
    erroredAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the step was reassigned.
     *
     * @generated from protobuf field: google.protobuf.Timestamp reassigned_at = 6
     */
    reassignedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.policy.v1.Escalation
 */
export interface Escalation {
    /**
     * @generated from protobuf field: int64 expiration = 1
     */
    expiration: number;
    /**
     * @generated from protobuf oneof: escalation_policy
     */
    escalationPolicy: {
        oneofKind: "replacePolicy";
        /**
         * @generated from protobuf field: c1.api.policy.v1.Escalation.ReplacePolicy replace_policy = 2
         */
        replacePolicy: Escalation_ReplacePolicy;
    } | {
        oneofKind: "reassignToApprovers";
        /**
         * @generated from protobuf field: c1.api.policy.v1.Escalation.ReassignToApprovers reassign_to_approvers = 3
         */
        reassignToApprovers: Escalation_ReassignToApprovers;
    } | {
        oneofKind: "cancelTicket";
        /**
         * @generated from protobuf field: c1.api.policy.v1.Escalation.CancelTicket cancel_ticket = 5
         */
        cancelTicket: Escalation_CancelTicket;
    } | {
        oneofKind: "skipStep";
        /**
         * @generated from protobuf field: c1.api.policy.v1.Escalation.SkipStep skip_step = 6
         */
        skipStep: Escalation_SkipStep;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string escalation_comment = 4
     */
    escalationComment: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.Escalation.ReplacePolicy
 */
export interface Escalation_ReplacePolicy {
    /**
     * @generated from protobuf field: string policy_id = 1
     */
    policyId: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.Escalation.ReassignToApprovers
 */
export interface Escalation_ReassignToApprovers {
    /**
     * @generated from protobuf field: repeated string approver_ids = 1
     */
    approverIds: string[];
}
/**
 * @generated from protobuf message c1.api.policy.v1.Escalation.CancelTicket
 */
export interface Escalation_CancelTicket {
}
/**
 * @generated from protobuf message c1.api.policy.v1.Escalation.SkipStep
 */
export interface Escalation_SkipStep {
}
/**
 * @generated from protobuf message c1.api.policy.v1.EscalationInstance
 */
export interface EscalationInstance {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 1
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf oneof: escalation_policy
     */
    escalationPolicy: {
        oneofKind: "replacePolicy";
        /**
         * @generated from protobuf field: c1.api.policy.v1.EscalationInstance.ReplacePolicy replace_policy = 2
         */
        replacePolicy: EscalationInstance_ReplacePolicy;
    } | {
        oneofKind: "reassignToApprovers";
        /**
         * @generated from protobuf field: c1.api.policy.v1.EscalationInstance.ReassignToApprovers reassign_to_approvers = 3
         */
        reassignToApprovers: EscalationInstance_ReassignToApprovers;
    } | {
        oneofKind: "cancelTicket";
        /**
         * @generated from protobuf field: c1.api.policy.v1.EscalationInstance.CancelTicket cancel_ticket = 6
         */
        cancelTicket: EscalationInstance_CancelTicket;
    } | {
        oneofKind: "skipStep";
        /**
         * @generated from protobuf field: c1.api.policy.v1.EscalationInstance.SkipStep skip_step = 7
         */
        skipStep: EscalationInstance_SkipStep;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string escalation_comment = 4
     */
    escalationComment: string;
    /**
     * @generated from protobuf field: bool already_escalated = 5
     */
    alreadyEscalated: boolean;
}
/**
 * @generated from protobuf message c1.api.policy.v1.EscalationInstance.ReplacePolicy
 */
export interface EscalationInstance_ReplacePolicy {
    /**
     * @generated from protobuf field: string policy_id = 1
     */
    policyId: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.EscalationInstance.ReassignToApprovers
 */
export interface EscalationInstance_ReassignToApprovers {
    /**
     * @generated from protobuf field: repeated string approver_ids = 1
     */
    approverIds: string[];
}
/**
 * @generated from protobuf message c1.api.policy.v1.EscalationInstance.CancelTicket
 */
export interface EscalationInstance_CancelTicket {
}
/**
 * @generated from protobuf message c1.api.policy.v1.EscalationInstance.SkipStep
 */
export interface EscalationInstance_SkipStep {
}
/**
 * If more types are added above please update them here
 *
 * @generated from protobuf enum c1.api.policy.v1.StepApprovalType
 */
export enum StepApprovalType {
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_USERS = 1;
     */
    USERS = 1,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_MANAGER = 2;
     */
    MANAGER = 2,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_APP_OWNERS = 3;
     */
    APP_OWNERS = 3,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_GROUP = 4;
     */
    GROUP = 4,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_SELF = 5;
     */
    SELF = 5,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_ENTITLEMENT_OWNERS = 6;
     */
    ENTITLEMENT_OWNERS = 6,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_EXPRESSION = 7;
     */
    EXPRESSION = 7,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_WEBHOOK = 8;
     */
    WEBHOOK = 8,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_RESOURCE_OWNERS = 9;
     */
    RESOURCE_OWNERS = 9,
    /**
     * @generated from protobuf enum value: STEP_APPROVAL_TYPE_AGENT = 10;
     */
    AGENT = 10
}
/**
 * @generated from protobuf enum c1.api.policy.v1.ApprovalInstanceState
 */
export enum ApprovalInstanceState {
    /**
     * Base state for when the data is not sent properly. Should be considered invalid.
     *
     * @generated from protobuf enum value: APPROVAL_INSTANCE_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The approval instance is being initialized, attempting to figure out who are the approvers.
     *
     * @generated from protobuf enum value: APPROVAL_INSTANCE_STATE_INIT = 1;
     */
    INIT = 1,
    /**
     * The approval instance is sending notifications to approvers.
     *
     * @generated from protobuf enum value: APPROVAL_INSTANCE_STATE_SENDING_NOTIFICATIONS = 2;
     */
    SENDING_NOTIFICATIONS = 2,
    /**
     * The approval instance is waiting for an approver to approve.
     *
     * @generated from protobuf enum value: APPROVAL_INSTANCE_STATE_WAITING = 3;
     */
    WAITING = 3,
    /**
     * The approval instance is complete.
     *
     * @generated from protobuf enum value: APPROVAL_INSTANCE_STATE_DONE = 4;
     */
    DONE = 4
}
/**
 * @generated from protobuf enum c1.api.policy.v1.ApprovalAgentMode
 */
export enum ApprovalAgentMode {
    /**
     * The agent mode is not set.
     *
     * @generated from protobuf enum value: APPROVAL_AGENT_MODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The agent has full control over the task - can approve, deny, and reassign.
     *
     * @generated from protobuf enum value: APPROVAL_AGENT_MODE_FULL_CONTROL = 1;
     */
    FULL_CONTROL = 1,
    /**
     * The agent can only change the policy of the task.
     *
     * @generated from protobuf enum value: APPROVAL_AGENT_MODE_CHANGE_POLICY_ONLY = 2;
     */
    CHANGE_POLICY_ONLY = 2,
    /**
     * The agent can only comment on the task.
     *
     * @generated from protobuf enum value: APPROVAL_AGENT_MODE_COMMENT_ONLY = 3;
     */
    COMMENT_ONLY = 3
}
/**
 * @generated from protobuf enum c1.api.policy.v1.ApprovalAgentFailureAction
 */
export enum ApprovalAgentFailureAction {
    /**
     * @generated from protobuf enum value: APPROVAL_AGENT_FAILURE_ACTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APPROVAL_AGENT_FAILURE_ACTION_REASSIGN_TO_USERS = 1;
     */
    REASSIGN_TO_USERS = 1,
    /**
     * @generated from protobuf enum value: APPROVAL_AGENT_FAILURE_ACTION_REASSIGN_TO_SUPER_ADMINS = 2;
     */
    REASSIGN_TO_SUPER_ADMINS = 2,
    /**
     * @generated from protobuf enum value: APPROVAL_AGENT_FAILURE_ACTION_SKIP_POLICY_STEP = 3;
     */
    SKIP_POLICY_STEP = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Approval$Type extends MessageType<Approval> {
    constructor() {
        super("c1.api.policy.v1.Approval", [
            { no: 1, name: "allow_reassignment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "require_reassignment_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "assigned", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "require_approval_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "require_denial_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "requires_step_up_provider_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 7, name: "allowed_reassignees", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 100, name: "users", kind: "message", oneof: "typ", T: () => UserApproval },
            { no: 101, name: "manager", kind: "message", oneof: "typ", T: () => ManagerApproval },
            { no: 102, name: "app_owners", kind: "message", oneof: "typ", T: () => AppOwnerApproval },
            { no: 103, name: "group", kind: "message", oneof: "typ", T: () => AppGroupApproval },
            { no: 104, name: "self", kind: "message", oneof: "typ", T: () => SelfApproval },
            { no: 105, name: "entitlement_owners", kind: "message", oneof: "typ", T: () => EntitlementOwnerApproval },
            { no: 106, name: "expression", kind: "message", oneof: "typ", T: () => ExpressionApproval },
            { no: 107, name: "webhook", kind: "message", oneof: "typ", T: () => WebhookApproval },
            { no: 108, name: "resource_owners", kind: "message", oneof: "typ", T: () => ResourceOwnerApproval },
            { no: 109, name: "agent", kind: "message", oneof: "typ", T: () => AgentApproval },
            { no: 8, name: "escalation_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "escalation", kind: "message", T: () => Escalation },
            { no: 10, name: "allow_delegation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Approval>): Approval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allowReassignment = false;
        message.requireReassignmentReason = false;
        message.assigned = false;
        message.requireApprovalReason = false;
        message.requireDenialReason = false;
        message.requiresStepUpProviderId = "";
        message.allowedReassignees = [];
        message.typ = { oneofKind: undefined };
        message.escalationEnabled = false;
        message.allowDelegation = false;
        if (value !== undefined)
            reflectionMergePartial<Approval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Approval): Approval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool allow_reassignment */ 1:
                    message.allowReassignment = reader.bool();
                    break;
                case /* bool require_reassignment_reason */ 2:
                    message.requireReassignmentReason = reader.bool();
                    break;
                case /* bool assigned */ 3:
                    message.assigned = reader.bool();
                    break;
                case /* bool require_approval_reason */ 4:
                    message.requireApprovalReason = reader.bool();
                    break;
                case /* bool require_denial_reason */ 5:
                    message.requireDenialReason = reader.bool();
                    break;
                case /* string requires_step_up_provider_id */ 6:
                    message.requiresStepUpProviderId = reader.string();
                    break;
                case /* repeated string allowed_reassignees */ 7:
                    message.allowedReassignees.push(reader.string());
                    break;
                case /* c1.api.policy.v1.UserApproval users */ 100:
                    message.typ = {
                        oneofKind: "users",
                        users: UserApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).users)
                    };
                    break;
                case /* c1.api.policy.v1.ManagerApproval manager */ 101:
                    message.typ = {
                        oneofKind: "manager",
                        manager: ManagerApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).manager)
                    };
                    break;
                case /* c1.api.policy.v1.AppOwnerApproval app_owners */ 102:
                    message.typ = {
                        oneofKind: "appOwners",
                        appOwners: AppOwnerApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).appOwners)
                    };
                    break;
                case /* c1.api.policy.v1.AppGroupApproval group */ 103:
                    message.typ = {
                        oneofKind: "group",
                        group: AppGroupApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).group)
                    };
                    break;
                case /* c1.api.policy.v1.SelfApproval self */ 104:
                    message.typ = {
                        oneofKind: "self",
                        self: SelfApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).self)
                    };
                    break;
                case /* c1.api.policy.v1.EntitlementOwnerApproval entitlement_owners */ 105:
                    message.typ = {
                        oneofKind: "entitlementOwners",
                        entitlementOwners: EntitlementOwnerApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).entitlementOwners)
                    };
                    break;
                case /* c1.api.policy.v1.ExpressionApproval expression */ 106:
                    message.typ = {
                        oneofKind: "expression",
                        expression: ExpressionApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).expression)
                    };
                    break;
                case /* c1.api.policy.v1.WebhookApproval webhook */ 107:
                    message.typ = {
                        oneofKind: "webhook",
                        webhook: WebhookApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).webhook)
                    };
                    break;
                case /* c1.api.policy.v1.ResourceOwnerApproval resource_owners */ 108:
                    message.typ = {
                        oneofKind: "resourceOwners",
                        resourceOwners: ResourceOwnerApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).resourceOwners)
                    };
                    break;
                case /* c1.api.policy.v1.AgentApproval agent */ 109:
                    message.typ = {
                        oneofKind: "agent",
                        agent: AgentApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).agent)
                    };
                    break;
                case /* bool escalation_enabled */ 8:
                    message.escalationEnabled = reader.bool();
                    break;
                case /* c1.api.policy.v1.Escalation escalation */ 9:
                    message.escalation = Escalation.internalBinaryRead(reader, reader.uint32(), options, message.escalation);
                    break;
                case /* bool allow_delegation */ 10:
                    message.allowDelegation = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Approval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool allow_reassignment = 1; */
        if (message.allowReassignment !== false)
            writer.tag(1, WireType.Varint).bool(message.allowReassignment);
        /* bool require_reassignment_reason = 2; */
        if (message.requireReassignmentReason !== false)
            writer.tag(2, WireType.Varint).bool(message.requireReassignmentReason);
        /* bool assigned = 3; */
        if (message.assigned !== false)
            writer.tag(3, WireType.Varint).bool(message.assigned);
        /* bool require_approval_reason = 4; */
        if (message.requireApprovalReason !== false)
            writer.tag(4, WireType.Varint).bool(message.requireApprovalReason);
        /* bool require_denial_reason = 5; */
        if (message.requireDenialReason !== false)
            writer.tag(5, WireType.Varint).bool(message.requireDenialReason);
        /* string requires_step_up_provider_id = 6; */
        if (message.requiresStepUpProviderId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.requiresStepUpProviderId);
        /* repeated string allowed_reassignees = 7; */
        for (let i = 0; i < message.allowedReassignees.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.allowedReassignees[i]);
        /* bool escalation_enabled = 8; */
        if (message.escalationEnabled !== false)
            writer.tag(8, WireType.Varint).bool(message.escalationEnabled);
        /* c1.api.policy.v1.Escalation escalation = 9; */
        if (message.escalation)
            Escalation.internalBinaryWrite(message.escalation, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool allow_delegation = 10; */
        if (message.allowDelegation !== false)
            writer.tag(10, WireType.Varint).bool(message.allowDelegation);
        /* c1.api.policy.v1.UserApproval users = 100; */
        if (message.typ.oneofKind === "users")
            UserApproval.internalBinaryWrite(message.typ.users, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.ManagerApproval manager = 101; */
        if (message.typ.oneofKind === "manager")
            ManagerApproval.internalBinaryWrite(message.typ.manager, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.AppOwnerApproval app_owners = 102; */
        if (message.typ.oneofKind === "appOwners")
            AppOwnerApproval.internalBinaryWrite(message.typ.appOwners, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.AppGroupApproval group = 103; */
        if (message.typ.oneofKind === "group")
            AppGroupApproval.internalBinaryWrite(message.typ.group, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.SelfApproval self = 104; */
        if (message.typ.oneofKind === "self")
            SelfApproval.internalBinaryWrite(message.typ.self, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.EntitlementOwnerApproval entitlement_owners = 105; */
        if (message.typ.oneofKind === "entitlementOwners")
            EntitlementOwnerApproval.internalBinaryWrite(message.typ.entitlementOwners, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.ExpressionApproval expression = 106; */
        if (message.typ.oneofKind === "expression")
            ExpressionApproval.internalBinaryWrite(message.typ.expression, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.WebhookApproval webhook = 107; */
        if (message.typ.oneofKind === "webhook")
            WebhookApproval.internalBinaryWrite(message.typ.webhook, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.ResourceOwnerApproval resource_owners = 108; */
        if (message.typ.oneofKind === "resourceOwners")
            ResourceOwnerApproval.internalBinaryWrite(message.typ.resourceOwners, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.AgentApproval agent = 109; */
        if (message.typ.oneofKind === "agent")
            AgentApproval.internalBinaryWrite(message.typ.agent, writer.tag(109, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Approval
 */
export const Approval = new Approval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApprovalInstance$Type extends MessageType<ApprovalInstance> {
    constructor() {
        super("c1.api.policy.v1.ApprovalInstance", [
            { no: 1, name: "approval", kind: "message", T: () => Approval, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "state", kind: "enum", T: () => ["c1.api.policy.v1.ApprovalInstanceState", ApprovalInstanceState, "APPROVAL_INSTANCE_STATE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 101, name: "approved", kind: "message", oneof: "outcome", T: () => ApprovedAction, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 102, name: "denied", kind: "message", oneof: "outcome", T: () => DeniedAction, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 103, name: "reassigned", kind: "message", oneof: "outcome", T: () => ReassignedAction, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 104, name: "restarted", kind: "message", oneof: "outcome", T: () => RestartAction, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 105, name: "reassigned_by_error", kind: "message", oneof: "outcome", T: () => ReassignedByErrorAction, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 106, name: "skipped", kind: "message", oneof: "outcome", T: () => SkippedAction, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "escalation_instance", kind: "message", T: () => EscalationInstance },
            { no: 4, name: "assigned_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<ApprovalInstance>): ApprovalInstance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.state = 0;
        message.outcome = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ApprovalInstance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ApprovalInstance): ApprovalInstance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.policy.v1.Approval approval */ 1:
                    message.approval = Approval.internalBinaryRead(reader, reader.uint32(), options, message.approval);
                    break;
                case /* c1.api.policy.v1.ApprovalInstanceState state */ 2:
                    message.state = reader.int32();
                    break;
                case /* c1.api.policy.v1.ApprovedAction approved */ 101:
                    message.outcome = {
                        oneofKind: "approved",
                        approved: ApprovedAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).approved)
                    };
                    break;
                case /* c1.api.policy.v1.DeniedAction denied */ 102:
                    message.outcome = {
                        oneofKind: "denied",
                        denied: DeniedAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).denied)
                    };
                    break;
                case /* c1.api.policy.v1.ReassignedAction reassigned */ 103:
                    message.outcome = {
                        oneofKind: "reassigned",
                        reassigned: ReassignedAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).reassigned)
                    };
                    break;
                case /* c1.api.policy.v1.RestartAction restarted */ 104:
                    message.outcome = {
                        oneofKind: "restarted",
                        restarted: RestartAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).restarted)
                    };
                    break;
                case /* c1.api.policy.v1.ReassignedByErrorAction reassigned_by_error */ 105:
                    message.outcome = {
                        oneofKind: "reassignedByError",
                        reassignedByError: ReassignedByErrorAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).reassignedByError)
                    };
                    break;
                case /* c1.api.policy.v1.SkippedAction skipped */ 106:
                    message.outcome = {
                        oneofKind: "skipped",
                        skipped: SkippedAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).skipped)
                    };
                    break;
                case /* c1.api.policy.v1.EscalationInstance escalation_instance */ 3:
                    message.escalationInstance = EscalationInstance.internalBinaryRead(reader, reader.uint32(), options, message.escalationInstance);
                    break;
                case /* google.protobuf.Timestamp assigned_at */ 4:
                    message.assignedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.assignedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ApprovalInstance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.policy.v1.Approval approval = 1; */
        if (message.approval)
            Approval.internalBinaryWrite(message.approval, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.ApprovalInstanceState state = 2; */
        if (message.state !== 0)
            writer.tag(2, WireType.Varint).int32(message.state);
        /* c1.api.policy.v1.EscalationInstance escalation_instance = 3; */
        if (message.escalationInstance)
            EscalationInstance.internalBinaryWrite(message.escalationInstance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp assigned_at = 4; */
        if (message.assignedAt)
            Timestamp.internalBinaryWrite(message.assignedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.ApprovedAction approved = 101; */
        if (message.outcome.oneofKind === "approved")
            ApprovedAction.internalBinaryWrite(message.outcome.approved, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.DeniedAction denied = 102; */
        if (message.outcome.oneofKind === "denied")
            DeniedAction.internalBinaryWrite(message.outcome.denied, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.ReassignedAction reassigned = 103; */
        if (message.outcome.oneofKind === "reassigned")
            ReassignedAction.internalBinaryWrite(message.outcome.reassigned, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.RestartAction restarted = 104; */
        if (message.outcome.oneofKind === "restarted")
            RestartAction.internalBinaryWrite(message.outcome.restarted, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.ReassignedByErrorAction reassigned_by_error = 105; */
        if (message.outcome.oneofKind === "reassignedByError")
            ReassignedByErrorAction.internalBinaryWrite(message.outcome.reassignedByError, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.SkippedAction skipped = 106; */
        if (message.outcome.oneofKind === "skipped")
            SkippedAction.internalBinaryWrite(message.outcome.skipped, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ApprovalInstance
 */
export const ApprovalInstance = new ApprovalInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApprovedAction$Type extends MessageType<ApprovedAction> {
    constructor() {
        super("c1.api.policy.v1.ApprovedAction", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementReference, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] }, "validate.rules": { repeated: { minItems: "1", maxItems: "32" } } } },
            { no: 3, name: "approved_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "step_up_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|^$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<ApprovedAction>): ApprovedAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.entitlements = [];
        message.stepUpTransactionId = "";
        if (value !== undefined)
            reflectionMergePartial<ApprovedAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ApprovedAction): ApprovedAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* repeated c1.api.policy.v1.AppEntitlementReference entitlements */ 2:
                    message.entitlements.push(AppEntitlementReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp approved_at */ 3:
                    message.approvedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.approvedAt);
                    break;
                case /* string step_up_transaction_id */ 4:
                    message.stepUpTransactionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ApprovedAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* repeated c1.api.policy.v1.AppEntitlementReference entitlements = 2; */
        for (let i = 0; i < message.entitlements.length; i++)
            AppEntitlementReference.internalBinaryWrite(message.entitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp approved_at = 3; */
        if (message.approvedAt)
            Timestamp.internalBinaryWrite(message.approvedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string step_up_transaction_id = 4; */
        if (message.stepUpTransactionId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.stepUpTransactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ApprovedAction
 */
export const ApprovedAction = new ApprovedAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementReference$Type extends MessageType<AppEntitlementReference> {
    constructor() {
        super("c1.api.policy.v1.AppEntitlementReference", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementReference>): AppEntitlementReference {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementReference>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementReference): AppEntitlementReference {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementReference, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.AppEntitlementReference
 */
export const AppEntitlementReference = new AppEntitlementReference$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeniedAction$Type extends MessageType<DeniedAction> {
    constructor() {
        super("c1.api.policy.v1.DeniedAction", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "denied_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<DeniedAction>): DeniedAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<DeniedAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeniedAction): DeniedAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* google.protobuf.Timestamp denied_at */ 2:
                    message.deniedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deniedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeniedAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* google.protobuf.Timestamp denied_at = 2; */
        if (message.deniedAt)
            Timestamp.internalBinaryWrite(message.deniedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.DeniedAction
 */
export const DeniedAction = new DeniedAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserApproval$Type extends MessageType<UserApproval> {
    constructor() {
        super("c1.api.policy.v1.UserApproval", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "allow_self_approval", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "require_distinct_approvers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UserApproval>): UserApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        message.allowSelfApproval = false;
        message.requireDistinctApprovers = false;
        if (value !== undefined)
            reflectionMergePartial<UserApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserApproval): UserApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string user_ids */ 1:
                    message.userIds.push(reader.string());
                    break;
                case /* bool allow_self_approval */ 2:
                    message.allowSelfApproval = reader.bool();
                    break;
                case /* bool require_distinct_approvers */ 3:
                    message.requireDistinctApprovers = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string user_ids = 1; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.userIds[i]);
        /* bool allow_self_approval = 2; */
        if (message.allowSelfApproval !== false)
            writer.tag(2, WireType.Varint).bool(message.allowSelfApproval);
        /* bool require_distinct_approvers = 3; */
        if (message.requireDistinctApprovers !== false)
            writer.tag(3, WireType.Varint).bool(message.requireDistinctApprovers);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.UserApproval
 */
export const UserApproval = new UserApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentApproval$Type extends MessageType<AgentApproval> {
    constructor() {
        super("c1.api.policy.v1.AgentApproval", [
            { no: 1, name: "agent_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "2048" } } } },
            { no: 3, name: "policy_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "agent_mode", kind: "enum", T: () => ["c1.api.policy.v1.ApprovalAgentMode", ApprovalAgentMode, "APPROVAL_AGENT_MODE_"] },
            { no: 5, name: "agent_failure_action", kind: "enum", T: () => ["c1.api.policy.v1.ApprovalAgentFailureAction", ApprovalAgentFailureAction, "APPROVAL_AGENT_FAILURE_ACTION_"] },
            { no: 6, name: "reassign_to_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AgentApproval>): AgentApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.agentUserId = "";
        message.instructions = "";
        message.policyIds = [];
        message.agentMode = 0;
        message.agentFailureAction = 0;
        message.reassignToUserIds = [];
        if (value !== undefined)
            reflectionMergePartial<AgentApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentApproval): AgentApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string agent_user_id */ 1:
                    message.agentUserId = reader.string();
                    break;
                case /* string instructions */ 2:
                    message.instructions = reader.string();
                    break;
                case /* repeated string policy_ids */ 3:
                    message.policyIds.push(reader.string());
                    break;
                case /* c1.api.policy.v1.ApprovalAgentMode agent_mode */ 4:
                    message.agentMode = reader.int32();
                    break;
                case /* c1.api.policy.v1.ApprovalAgentFailureAction agent_failure_action */ 5:
                    message.agentFailureAction = reader.int32();
                    break;
                case /* repeated string reassign_to_user_ids */ 6:
                    message.reassignToUserIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string agent_user_id = 1; */
        if (message.agentUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.agentUserId);
        /* string instructions = 2; */
        if (message.instructions !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.instructions);
        /* repeated string policy_ids = 3; */
        for (let i = 0; i < message.policyIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.policyIds[i]);
        /* c1.api.policy.v1.ApprovalAgentMode agent_mode = 4; */
        if (message.agentMode !== 0)
            writer.tag(4, WireType.Varint).int32(message.agentMode);
        /* c1.api.policy.v1.ApprovalAgentFailureAction agent_failure_action = 5; */
        if (message.agentFailureAction !== 0)
            writer.tag(5, WireType.Varint).int32(message.agentFailureAction);
        /* repeated string reassign_to_user_ids = 6; */
        for (let i = 0; i < message.reassignToUserIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.reassignToUserIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.AgentApproval
 */
export const AgentApproval = new AgentApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManagerApproval$Type extends MessageType<ManagerApproval> {
    constructor() {
        super("c1.api.policy.v1.ManagerApproval", [
            { no: 1, name: "fallback_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "fallback", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "allow_self_approval", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "assigned_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] }, "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "require_distinct_approvers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "fallback_group_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementReference, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "is_group_fallback_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ManagerApproval>): ManagerApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fallbackUserIds = [];
        message.fallback = false;
        message.allowSelfApproval = false;
        message.assignedUserIds = [];
        message.requireDistinctApprovers = false;
        message.fallbackGroupIds = [];
        message.isGroupFallbackEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<ManagerApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ManagerApproval): ManagerApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string fallback_user_ids */ 1:
                    message.fallbackUserIds.push(reader.string());
                    break;
                case /* bool fallback */ 2:
                    message.fallback = reader.bool();
                    break;
                case /* bool allow_self_approval */ 3:
                    message.allowSelfApproval = reader.bool();
                    break;
                case /* repeated string assigned_user_ids */ 4:
                    message.assignedUserIds.push(reader.string());
                    break;
                case /* bool require_distinct_approvers */ 5:
                    message.requireDistinctApprovers = reader.bool();
                    break;
                case /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids */ 6:
                    message.fallbackGroupIds.push(AppEntitlementReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_group_fallback_enabled */ 7:
                    message.isGroupFallbackEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ManagerApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string fallback_user_ids = 1; */
        for (let i = 0; i < message.fallbackUserIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.fallbackUserIds[i]);
        /* bool fallback = 2; */
        if (message.fallback !== false)
            writer.tag(2, WireType.Varint).bool(message.fallback);
        /* bool allow_self_approval = 3; */
        if (message.allowSelfApproval !== false)
            writer.tag(3, WireType.Varint).bool(message.allowSelfApproval);
        /* repeated string assigned_user_ids = 4; */
        for (let i = 0; i < message.assignedUserIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.assignedUserIds[i]);
        /* bool require_distinct_approvers = 5; */
        if (message.requireDistinctApprovers !== false)
            writer.tag(5, WireType.Varint).bool(message.requireDistinctApprovers);
        /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 6; */
        for (let i = 0; i < message.fallbackGroupIds.length; i++)
            AppEntitlementReference.internalBinaryWrite(message.fallbackGroupIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool is_group_fallback_enabled = 7; */
        if (message.isGroupFallbackEnabled !== false)
            writer.tag(7, WireType.Varint).bool(message.isGroupFallbackEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ManagerApproval
 */
export const ManagerApproval = new ManagerApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppOwnerApproval$Type extends MessageType<AppOwnerApproval> {
    constructor() {
        super("c1.api.policy.v1.AppOwnerApproval", [
            { no: 1, name: "allow_self_approval", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "require_distinct_approvers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppOwnerApproval>): AppOwnerApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allowSelfApproval = false;
        message.requireDistinctApprovers = false;
        if (value !== undefined)
            reflectionMergePartial<AppOwnerApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppOwnerApproval): AppOwnerApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool allow_self_approval */ 1:
                    message.allowSelfApproval = reader.bool();
                    break;
                case /* bool require_distinct_approvers */ 2:
                    message.requireDistinctApprovers = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppOwnerApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool allow_self_approval = 1; */
        if (message.allowSelfApproval !== false)
            writer.tag(1, WireType.Varint).bool(message.allowSelfApproval);
        /* bool require_distinct_approvers = 2; */
        if (message.requireDistinctApprovers !== false)
            writer.tag(2, WireType.Varint).bool(message.requireDistinctApprovers);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.AppOwnerApproval
 */
export const AppOwnerApproval = new AppOwnerApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementOwnerApproval$Type extends MessageType<EntitlementOwnerApproval> {
    constructor() {
        super("c1.api.policy.v1.EntitlementOwnerApproval", [
            { no: 1, name: "allow_self_approval", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "fallback_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "fallback", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "require_distinct_approvers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "fallback_group_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementReference, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "is_group_fallback_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<EntitlementOwnerApproval>): EntitlementOwnerApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allowSelfApproval = false;
        message.fallbackUserIds = [];
        message.fallback = false;
        message.requireDistinctApprovers = false;
        message.fallbackGroupIds = [];
        message.isGroupFallbackEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<EntitlementOwnerApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementOwnerApproval): EntitlementOwnerApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool allow_self_approval */ 1:
                    message.allowSelfApproval = reader.bool();
                    break;
                case /* repeated string fallback_user_ids */ 2:
                    message.fallbackUserIds.push(reader.string());
                    break;
                case /* bool fallback */ 3:
                    message.fallback = reader.bool();
                    break;
                case /* bool require_distinct_approvers */ 4:
                    message.requireDistinctApprovers = reader.bool();
                    break;
                case /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids */ 5:
                    message.fallbackGroupIds.push(AppEntitlementReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_group_fallback_enabled */ 6:
                    message.isGroupFallbackEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementOwnerApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool allow_self_approval = 1; */
        if (message.allowSelfApproval !== false)
            writer.tag(1, WireType.Varint).bool(message.allowSelfApproval);
        /* repeated string fallback_user_ids = 2; */
        for (let i = 0; i < message.fallbackUserIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.fallbackUserIds[i]);
        /* bool fallback = 3; */
        if (message.fallback !== false)
            writer.tag(3, WireType.Varint).bool(message.fallback);
        /* bool require_distinct_approvers = 4; */
        if (message.requireDistinctApprovers !== false)
            writer.tag(4, WireType.Varint).bool(message.requireDistinctApprovers);
        /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 5; */
        for (let i = 0; i < message.fallbackGroupIds.length; i++)
            AppEntitlementReference.internalBinaryWrite(message.fallbackGroupIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool is_group_fallback_enabled = 6; */
        if (message.isGroupFallbackEnabled !== false)
            writer.tag(6, WireType.Varint).bool(message.isGroupFallbackEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.EntitlementOwnerApproval
 */
export const EntitlementOwnerApproval = new EntitlementOwnerApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceOwnerApproval$Type extends MessageType<ResourceOwnerApproval> {
    constructor() {
        super("c1.api.policy.v1.ResourceOwnerApproval", [
            { no: 1, name: "allow_self_approval", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "fallback_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "fallback", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "require_distinct_approvers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "fallback_group_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementReference, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "is_group_fallback_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ResourceOwnerApproval>): ResourceOwnerApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allowSelfApproval = false;
        message.fallbackUserIds = [];
        message.fallback = false;
        message.requireDistinctApprovers = false;
        message.fallbackGroupIds = [];
        message.isGroupFallbackEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<ResourceOwnerApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceOwnerApproval): ResourceOwnerApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool allow_self_approval */ 1:
                    message.allowSelfApproval = reader.bool();
                    break;
                case /* repeated string fallback_user_ids */ 2:
                    message.fallbackUserIds.push(reader.string());
                    break;
                case /* bool fallback */ 3:
                    message.fallback = reader.bool();
                    break;
                case /* bool require_distinct_approvers */ 4:
                    message.requireDistinctApprovers = reader.bool();
                    break;
                case /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids */ 5:
                    message.fallbackGroupIds.push(AppEntitlementReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_group_fallback_enabled */ 6:
                    message.isGroupFallbackEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceOwnerApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool allow_self_approval = 1; */
        if (message.allowSelfApproval !== false)
            writer.tag(1, WireType.Varint).bool(message.allowSelfApproval);
        /* repeated string fallback_user_ids = 2; */
        for (let i = 0; i < message.fallbackUserIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.fallbackUserIds[i]);
        /* bool fallback = 3; */
        if (message.fallback !== false)
            writer.tag(3, WireType.Varint).bool(message.fallback);
        /* bool require_distinct_approvers = 4; */
        if (message.requireDistinctApprovers !== false)
            writer.tag(4, WireType.Varint).bool(message.requireDistinctApprovers);
        /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 5; */
        for (let i = 0; i < message.fallbackGroupIds.length; i++)
            AppEntitlementReference.internalBinaryWrite(message.fallbackGroupIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool is_group_fallback_enabled = 6; */
        if (message.isGroupFallbackEnabled !== false)
            writer.tag(6, WireType.Varint).bool(message.isGroupFallbackEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ResourceOwnerApproval
 */
export const ResourceOwnerApproval = new ResourceOwnerApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelfApproval$Type extends MessageType<SelfApproval> {
    constructor() {
        super("c1.api.policy.v1.SelfApproval", [
            { no: 1, name: "fallback_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "fallback", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "assigned_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] }, "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "fallback_group_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementReference, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "is_group_fallback_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SelfApproval>): SelfApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fallbackUserIds = [];
        message.fallback = false;
        message.assignedUserIds = [];
        message.fallbackGroupIds = [];
        message.isGroupFallbackEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<SelfApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SelfApproval): SelfApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string fallback_user_ids */ 1:
                    message.fallbackUserIds.push(reader.string());
                    break;
                case /* bool fallback */ 2:
                    message.fallback = reader.bool();
                    break;
                case /* repeated string assigned_user_ids */ 3:
                    message.assignedUserIds.push(reader.string());
                    break;
                case /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids */ 4:
                    message.fallbackGroupIds.push(AppEntitlementReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_group_fallback_enabled */ 5:
                    message.isGroupFallbackEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SelfApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string fallback_user_ids = 1; */
        for (let i = 0; i < message.fallbackUserIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.fallbackUserIds[i]);
        /* bool fallback = 2; */
        if (message.fallback !== false)
            writer.tag(2, WireType.Varint).bool(message.fallback);
        /* repeated string assigned_user_ids = 3; */
        for (let i = 0; i < message.assignedUserIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.assignedUserIds[i]);
        /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 4; */
        for (let i = 0; i < message.fallbackGroupIds.length; i++)
            AppEntitlementReference.internalBinaryWrite(message.fallbackGroupIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool is_group_fallback_enabled = 5; */
        if (message.isGroupFallbackEnabled !== false)
            writer.tag(5, WireType.Varint).bool(message.isGroupFallbackEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.SelfApproval
 */
export const SelfApproval = new SelfApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppGroupApproval$Type extends MessageType<AppGroupApproval> {
    constructor() {
        super("c1.api.policy.v1.AppGroupApproval", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "allow_self_approval", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "fallback_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "fallback", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "fallback_group_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementReference, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "is_group_fallback_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "require_distinct_approvers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppGroupApproval>): AppGroupApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appGroupId = "";
        message.allowSelfApproval = false;
        message.fallbackUserIds = [];
        message.fallback = false;
        message.fallbackGroupIds = [];
        message.isGroupFallbackEnabled = false;
        message.requireDistinctApprovers = false;
        if (value !== undefined)
            reflectionMergePartial<AppGroupApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppGroupApproval): AppGroupApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_group_id */ 2:
                    message.appGroupId = reader.string();
                    break;
                case /* bool allow_self_approval */ 3:
                    message.allowSelfApproval = reader.bool();
                    break;
                case /* repeated string fallback_user_ids */ 4:
                    message.fallbackUserIds.push(reader.string());
                    break;
                case /* bool fallback */ 5:
                    message.fallback = reader.bool();
                    break;
                case /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids */ 6:
                    message.fallbackGroupIds.push(AppEntitlementReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_group_fallback_enabled */ 7:
                    message.isGroupFallbackEnabled = reader.bool();
                    break;
                case /* bool require_distinct_approvers */ 8:
                    message.requireDistinctApprovers = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppGroupApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_group_id = 2; */
        if (message.appGroupId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appGroupId);
        /* bool allow_self_approval = 3; */
        if (message.allowSelfApproval !== false)
            writer.tag(3, WireType.Varint).bool(message.allowSelfApproval);
        /* repeated string fallback_user_ids = 4; */
        for (let i = 0; i < message.fallbackUserIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fallbackUserIds[i]);
        /* bool fallback = 5; */
        if (message.fallback !== false)
            writer.tag(5, WireType.Varint).bool(message.fallback);
        /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 6; */
        for (let i = 0; i < message.fallbackGroupIds.length; i++)
            AppEntitlementReference.internalBinaryWrite(message.fallbackGroupIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool is_group_fallback_enabled = 7; */
        if (message.isGroupFallbackEnabled !== false)
            writer.tag(7, WireType.Varint).bool(message.isGroupFallbackEnabled);
        /* bool require_distinct_approvers = 8; */
        if (message.requireDistinctApprovers !== false)
            writer.tag(8, WireType.Varint).bool(message.requireDistinctApprovers);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.AppGroupApproval
 */
export const AppGroupApproval = new AppGroupApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpressionApproval$Type extends MessageType<ExpressionApproval> {
    constructor() {
        super("c1.api.policy.v1.ExpressionApproval", [
            { no: 1, name: "expressions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "16", items: { string: { minBytes: "1", maxBytes: "2048" } } } } } },
            { no: 2, name: "allow_self_approval", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "fallback", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "fallback_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "assigned_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] }, "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "require_distinct_approvers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "fallback_group_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementReference, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 8, name: "is_group_fallback_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ExpressionApproval>): ExpressionApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expressions = [];
        message.allowSelfApproval = false;
        message.fallback = false;
        message.fallbackUserIds = [];
        message.assignedUserIds = [];
        message.requireDistinctApprovers = false;
        message.fallbackGroupIds = [];
        message.isGroupFallbackEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<ExpressionApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpressionApproval): ExpressionApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string expressions */ 1:
                    message.expressions.push(reader.string());
                    break;
                case /* bool allow_self_approval */ 2:
                    message.allowSelfApproval = reader.bool();
                    break;
                case /* bool fallback */ 3:
                    message.fallback = reader.bool();
                    break;
                case /* repeated string fallback_user_ids */ 4:
                    message.fallbackUserIds.push(reader.string());
                    break;
                case /* repeated string assigned_user_ids */ 5:
                    message.assignedUserIds.push(reader.string());
                    break;
                case /* bool require_distinct_approvers */ 6:
                    message.requireDistinctApprovers = reader.bool();
                    break;
                case /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids */ 7:
                    message.fallbackGroupIds.push(AppEntitlementReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_group_fallback_enabled */ 8:
                    message.isGroupFallbackEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpressionApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string expressions = 1; */
        for (let i = 0; i < message.expressions.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.expressions[i]);
        /* bool allow_self_approval = 2; */
        if (message.allowSelfApproval !== false)
            writer.tag(2, WireType.Varint).bool(message.allowSelfApproval);
        /* bool fallback = 3; */
        if (message.fallback !== false)
            writer.tag(3, WireType.Varint).bool(message.fallback);
        /* repeated string fallback_user_ids = 4; */
        for (let i = 0; i < message.fallbackUserIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fallbackUserIds[i]);
        /* repeated string assigned_user_ids = 5; */
        for (let i = 0; i < message.assignedUserIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.assignedUserIds[i]);
        /* bool require_distinct_approvers = 6; */
        if (message.requireDistinctApprovers !== false)
            writer.tag(6, WireType.Varint).bool(message.requireDistinctApprovers);
        /* repeated c1.api.policy.v1.AppEntitlementReference fallback_group_ids = 7; */
        for (let i = 0; i < message.fallbackGroupIds.length; i++)
            AppEntitlementReference.internalBinaryWrite(message.fallbackGroupIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool is_group_fallback_enabled = 8; */
        if (message.isGroupFallbackEnabled !== false)
            writer.tag(8, WireType.Varint).bool(message.isGroupFallbackEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ExpressionApproval
 */
export const ExpressionApproval = new ExpressionApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookApproval$Type extends MessageType<WebhookApproval> {
    constructor() {
        super("c1.api.policy.v1.WebhookApproval", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhookApproval>): WebhookApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookApproval): WebhookApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WebhookApproval
 */
export const WebhookApproval = new WebhookApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReassignedByErrorAction$Type extends MessageType<ReassignedByErrorAction> {
    constructor() {
        super("c1.api.policy.v1.ReassignedByErrorAction", [
            { no: 1, name: "error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "error_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "new_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "errored_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "reassigned_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<ReassignedByErrorAction>): ReassignedByErrorAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.errorCode = "";
        message.description = "";
        message.errorUserId = "";
        message.newPolicyStepId = "";
        if (value !== undefined)
            reflectionMergePartial<ReassignedByErrorAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReassignedByErrorAction): ReassignedByErrorAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string error_code */ 1:
                    message.errorCode = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string error_user_id */ 3:
                    message.errorUserId = reader.string();
                    break;
                case /* string new_policy_step_id */ 4:
                    message.newPolicyStepId = reader.string();
                    break;
                case /* google.protobuf.Timestamp errored_at */ 5:
                    message.erroredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.erroredAt);
                    break;
                case /* google.protobuf.Timestamp reassigned_at */ 6:
                    message.reassignedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.reassignedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReassignedByErrorAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string error_code = 1; */
        if (message.errorCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.errorCode);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string error_user_id = 3; */
        if (message.errorUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorUserId);
        /* string new_policy_step_id = 4; */
        if (message.newPolicyStepId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.newPolicyStepId);
        /* google.protobuf.Timestamp errored_at = 5; */
        if (message.erroredAt)
            Timestamp.internalBinaryWrite(message.erroredAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp reassigned_at = 6; */
        if (message.reassignedAt)
            Timestamp.internalBinaryWrite(message.reassignedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.ReassignedByErrorAction
 */
export const ReassignedByErrorAction = new ReassignedByErrorAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Escalation$Type extends MessageType<Escalation> {
    constructor() {
        super("c1.api.policy.v1.Escalation", [
            { no: 1, name: "expiration", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "replace_policy", kind: "message", oneof: "escalationPolicy", T: () => Escalation_ReplacePolicy },
            { no: 3, name: "reassign_to_approvers", kind: "message", oneof: "escalationPolicy", T: () => Escalation_ReassignToApprovers },
            { no: 5, name: "cancel_ticket", kind: "message", oneof: "escalationPolicy", T: () => Escalation_CancelTicket },
            { no: 6, name: "skip_step", kind: "message", oneof: "escalationPolicy", T: () => Escalation_SkipStep },
            { no: 4, name: "escalation_comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<Escalation>): Escalation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expiration = 0;
        message.escalationPolicy = { oneofKind: undefined };
        message.escalationComment = "";
        if (value !== undefined)
            reflectionMergePartial<Escalation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Escalation): Escalation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 expiration */ 1:
                    message.expiration = reader.int64().toNumber();
                    break;
                case /* c1.api.policy.v1.Escalation.ReplacePolicy replace_policy */ 2:
                    message.escalationPolicy = {
                        oneofKind: "replacePolicy",
                        replacePolicy: Escalation_ReplacePolicy.internalBinaryRead(reader, reader.uint32(), options, (message.escalationPolicy as any).replacePolicy)
                    };
                    break;
                case /* c1.api.policy.v1.Escalation.ReassignToApprovers reassign_to_approvers */ 3:
                    message.escalationPolicy = {
                        oneofKind: "reassignToApprovers",
                        reassignToApprovers: Escalation_ReassignToApprovers.internalBinaryRead(reader, reader.uint32(), options, (message.escalationPolicy as any).reassignToApprovers)
                    };
                    break;
                case /* c1.api.policy.v1.Escalation.CancelTicket cancel_ticket */ 5:
                    message.escalationPolicy = {
                        oneofKind: "cancelTicket",
                        cancelTicket: Escalation_CancelTicket.internalBinaryRead(reader, reader.uint32(), options, (message.escalationPolicy as any).cancelTicket)
                    };
                    break;
                case /* c1.api.policy.v1.Escalation.SkipStep skip_step */ 6:
                    message.escalationPolicy = {
                        oneofKind: "skipStep",
                        skipStep: Escalation_SkipStep.internalBinaryRead(reader, reader.uint32(), options, (message.escalationPolicy as any).skipStep)
                    };
                    break;
                case /* string escalation_comment */ 4:
                    message.escalationComment = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Escalation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 expiration = 1; */
        if (message.expiration !== 0)
            writer.tag(1, WireType.Varint).int64(message.expiration);
        /* c1.api.policy.v1.Escalation.ReplacePolicy replace_policy = 2; */
        if (message.escalationPolicy.oneofKind === "replacePolicy")
            Escalation_ReplacePolicy.internalBinaryWrite(message.escalationPolicy.replacePolicy, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.Escalation.ReassignToApprovers reassign_to_approvers = 3; */
        if (message.escalationPolicy.oneofKind === "reassignToApprovers")
            Escalation_ReassignToApprovers.internalBinaryWrite(message.escalationPolicy.reassignToApprovers, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string escalation_comment = 4; */
        if (message.escalationComment !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.escalationComment);
        /* c1.api.policy.v1.Escalation.CancelTicket cancel_ticket = 5; */
        if (message.escalationPolicy.oneofKind === "cancelTicket")
            Escalation_CancelTicket.internalBinaryWrite(message.escalationPolicy.cancelTicket, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.Escalation.SkipStep skip_step = 6; */
        if (message.escalationPolicy.oneofKind === "skipStep")
            Escalation_SkipStep.internalBinaryWrite(message.escalationPolicy.skipStep, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Escalation
 */
export const Escalation = new Escalation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Escalation_ReplacePolicy$Type extends MessageType<Escalation_ReplacePolicy> {
    constructor() {
        super("c1.api.policy.v1.Escalation.ReplacePolicy", [
            { no: 1, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Escalation_ReplacePolicy>): Escalation_ReplacePolicy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.policyId = "";
        if (value !== undefined)
            reflectionMergePartial<Escalation_ReplacePolicy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Escalation_ReplacePolicy): Escalation_ReplacePolicy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string policy_id */ 1:
                    message.policyId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Escalation_ReplacePolicy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string policy_id = 1; */
        if (message.policyId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.policyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Escalation.ReplacePolicy
 */
export const Escalation_ReplacePolicy = new Escalation_ReplacePolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Escalation_ReassignToApprovers$Type extends MessageType<Escalation_ReassignToApprovers> {
    constructor() {
        super("c1.api.policy.v1.Escalation.ReassignToApprovers", [
            { no: 1, name: "approver_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Escalation_ReassignToApprovers>): Escalation_ReassignToApprovers {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.approverIds = [];
        if (value !== undefined)
            reflectionMergePartial<Escalation_ReassignToApprovers>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Escalation_ReassignToApprovers): Escalation_ReassignToApprovers {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string approver_ids */ 1:
                    message.approverIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Escalation_ReassignToApprovers, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string approver_ids = 1; */
        for (let i = 0; i < message.approverIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.approverIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Escalation.ReassignToApprovers
 */
export const Escalation_ReassignToApprovers = new Escalation_ReassignToApprovers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Escalation_CancelTicket$Type extends MessageType<Escalation_CancelTicket> {
    constructor() {
        super("c1.api.policy.v1.Escalation.CancelTicket", []);
    }
    create(value?: PartialMessage<Escalation_CancelTicket>): Escalation_CancelTicket {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Escalation_CancelTicket>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Escalation_CancelTicket): Escalation_CancelTicket {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Escalation_CancelTicket, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Escalation.CancelTicket
 */
export const Escalation_CancelTicket = new Escalation_CancelTicket$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Escalation_SkipStep$Type extends MessageType<Escalation_SkipStep> {
    constructor() {
        super("c1.api.policy.v1.Escalation.SkipStep", []);
    }
    create(value?: PartialMessage<Escalation_SkipStep>): Escalation_SkipStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Escalation_SkipStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Escalation_SkipStep): Escalation_SkipStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Escalation_SkipStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Escalation.SkipStep
 */
export const Escalation_SkipStep = new Escalation_SkipStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EscalationInstance$Type extends MessageType<EscalationInstance> {
    constructor() {
        super("c1.api.policy.v1.EscalationInstance", [
            { no: 1, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 2, name: "replace_policy", kind: "message", oneof: "escalationPolicy", T: () => EscalationInstance_ReplacePolicy },
            { no: 3, name: "reassign_to_approvers", kind: "message", oneof: "escalationPolicy", T: () => EscalationInstance_ReassignToApprovers },
            { no: 6, name: "cancel_ticket", kind: "message", oneof: "escalationPolicy", T: () => EscalationInstance_CancelTicket },
            { no: 7, name: "skip_step", kind: "message", oneof: "escalationPolicy", T: () => EscalationInstance_SkipStep },
            { no: 4, name: "escalation_comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "already_escalated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<EscalationInstance>): EscalationInstance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.escalationPolicy = { oneofKind: undefined };
        message.escalationComment = "";
        message.alreadyEscalated = false;
        if (value !== undefined)
            reflectionMergePartial<EscalationInstance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EscalationInstance): EscalationInstance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp expires_at */ 1:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* c1.api.policy.v1.EscalationInstance.ReplacePolicy replace_policy */ 2:
                    message.escalationPolicy = {
                        oneofKind: "replacePolicy",
                        replacePolicy: EscalationInstance_ReplacePolicy.internalBinaryRead(reader, reader.uint32(), options, (message.escalationPolicy as any).replacePolicy)
                    };
                    break;
                case /* c1.api.policy.v1.EscalationInstance.ReassignToApprovers reassign_to_approvers */ 3:
                    message.escalationPolicy = {
                        oneofKind: "reassignToApprovers",
                        reassignToApprovers: EscalationInstance_ReassignToApprovers.internalBinaryRead(reader, reader.uint32(), options, (message.escalationPolicy as any).reassignToApprovers)
                    };
                    break;
                case /* c1.api.policy.v1.EscalationInstance.CancelTicket cancel_ticket */ 6:
                    message.escalationPolicy = {
                        oneofKind: "cancelTicket",
                        cancelTicket: EscalationInstance_CancelTicket.internalBinaryRead(reader, reader.uint32(), options, (message.escalationPolicy as any).cancelTicket)
                    };
                    break;
                case /* c1.api.policy.v1.EscalationInstance.SkipStep skip_step */ 7:
                    message.escalationPolicy = {
                        oneofKind: "skipStep",
                        skipStep: EscalationInstance_SkipStep.internalBinaryRead(reader, reader.uint32(), options, (message.escalationPolicy as any).skipStep)
                    };
                    break;
                case /* string escalation_comment */ 4:
                    message.escalationComment = reader.string();
                    break;
                case /* bool already_escalated */ 5:
                    message.alreadyEscalated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EscalationInstance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp expires_at = 1; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.EscalationInstance.ReplacePolicy replace_policy = 2; */
        if (message.escalationPolicy.oneofKind === "replacePolicy")
            EscalationInstance_ReplacePolicy.internalBinaryWrite(message.escalationPolicy.replacePolicy, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.EscalationInstance.ReassignToApprovers reassign_to_approvers = 3; */
        if (message.escalationPolicy.oneofKind === "reassignToApprovers")
            EscalationInstance_ReassignToApprovers.internalBinaryWrite(message.escalationPolicy.reassignToApprovers, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string escalation_comment = 4; */
        if (message.escalationComment !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.escalationComment);
        /* bool already_escalated = 5; */
        if (message.alreadyEscalated !== false)
            writer.tag(5, WireType.Varint).bool(message.alreadyEscalated);
        /* c1.api.policy.v1.EscalationInstance.CancelTicket cancel_ticket = 6; */
        if (message.escalationPolicy.oneofKind === "cancelTicket")
            EscalationInstance_CancelTicket.internalBinaryWrite(message.escalationPolicy.cancelTicket, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.EscalationInstance.SkipStep skip_step = 7; */
        if (message.escalationPolicy.oneofKind === "skipStep")
            EscalationInstance_SkipStep.internalBinaryWrite(message.escalationPolicy.skipStep, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.EscalationInstance
 */
export const EscalationInstance = new EscalationInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EscalationInstance_ReplacePolicy$Type extends MessageType<EscalationInstance_ReplacePolicy> {
    constructor() {
        super("c1.api.policy.v1.EscalationInstance.ReplacePolicy", [
            { no: 1, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EscalationInstance_ReplacePolicy>): EscalationInstance_ReplacePolicy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.policyId = "";
        if (value !== undefined)
            reflectionMergePartial<EscalationInstance_ReplacePolicy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EscalationInstance_ReplacePolicy): EscalationInstance_ReplacePolicy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string policy_id */ 1:
                    message.policyId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EscalationInstance_ReplacePolicy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string policy_id = 1; */
        if (message.policyId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.policyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.EscalationInstance.ReplacePolicy
 */
export const EscalationInstance_ReplacePolicy = new EscalationInstance_ReplacePolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EscalationInstance_ReassignToApprovers$Type extends MessageType<EscalationInstance_ReassignToApprovers> {
    constructor() {
        super("c1.api.policy.v1.EscalationInstance.ReassignToApprovers", [
            { no: 1, name: "approver_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EscalationInstance_ReassignToApprovers>): EscalationInstance_ReassignToApprovers {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.approverIds = [];
        if (value !== undefined)
            reflectionMergePartial<EscalationInstance_ReassignToApprovers>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EscalationInstance_ReassignToApprovers): EscalationInstance_ReassignToApprovers {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string approver_ids */ 1:
                    message.approverIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EscalationInstance_ReassignToApprovers, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string approver_ids = 1; */
        for (let i = 0; i < message.approverIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.approverIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.EscalationInstance.ReassignToApprovers
 */
export const EscalationInstance_ReassignToApprovers = new EscalationInstance_ReassignToApprovers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EscalationInstance_CancelTicket$Type extends MessageType<EscalationInstance_CancelTicket> {
    constructor() {
        super("c1.api.policy.v1.EscalationInstance.CancelTicket", []);
    }
    create(value?: PartialMessage<EscalationInstance_CancelTicket>): EscalationInstance_CancelTicket {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EscalationInstance_CancelTicket>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EscalationInstance_CancelTicket): EscalationInstance_CancelTicket {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EscalationInstance_CancelTicket, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.EscalationInstance.CancelTicket
 */
export const EscalationInstance_CancelTicket = new EscalationInstance_CancelTicket$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EscalationInstance_SkipStep$Type extends MessageType<EscalationInstance_SkipStep> {
    constructor() {
        super("c1.api.policy.v1.EscalationInstance.SkipStep", []);
    }
    create(value?: PartialMessage<EscalationInstance_SkipStep>): EscalationInstance_SkipStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EscalationInstance_SkipStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EscalationInstance_SkipStep): EscalationInstance_SkipStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EscalationInstance_SkipStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.EscalationInstance.SkipStep
 */
export const EscalationInstance_SkipStep = new EscalationInstance_SkipStep$Type();
